import { Box, Container, Grid } from "@material-ui/core";
import React from "react";
import { BsChevronRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
interface BreadCrumbLinksProps {
  currentPage: string;
  cf?: boolean | any;
}
export default function BreadCrumbLinks({
  currentPage,
  cf = false,
}: BreadCrumbLinksProps) {
  var prevPage = {
    name: "チケットを選ぶ",
    link: "/support/menu",
  };
  if (window.location.pathname == "/support/reservation-date-change") {
    prevPage = {
      name: "お支払い履歴",
      link: "/purchase-list",
    };
  }
  var breadcrumbs = [
    {
      name: "ホーム",
      link: "/",
    },
    { ...prevPage },
    {
      name: "日時/相談員を選ぶ",
      link: "/support/staff",
    },
    {
      name: "お支払い",
      link: "/buy",
    },
  ];

  const navigate = useNavigate();
  const getCurrentBreadcrumbIndex = () => {
    return breadcrumbs.findIndex(
      (breadcrumb) => breadcrumb.name === currentPage
    );
  };
  function handleClick(breadcrumb, useLink) {
    if (!useLink) {
      return;
    }
    console.log(breadcrumb.name);
    if (breadcrumb.name != "日時/相談員を選ぶ") {
      navigate(breadcrumb.link);
    } else {
      cf();
    }
  }
  return (
    <Box className="breadcrumb-links">
      <Container className="container">
        <Grid container alignItems="center">
          {breadcrumbs.map((breadcrumb, index) => {
            const isActive = breadcrumb.name === currentPage;
            if (index <= getCurrentBreadcrumbIndex()) {
              return (
                <Grid key={index} item md={"auto"} sm={"auto"} xs={"auto"}>
                  <div
                    className={`breadcrumb-link ${isActive ? "active" : ""} ${
                      index < getCurrentBreadcrumbIndex() ? "chev-right" : ""
                    }`}
                    onClick={() => {
                      handleClick(
                        breadcrumb,
                        index < getCurrentBreadcrumbIndex()
                      );
                    }}
                  >
                    <span>{breadcrumb.name}</span>
                    {index < getCurrentBreadcrumbIndex() ? (
                      <BsChevronRight />
                    ) : (
                      ""
                    )}
                  </div>
                </Grid>
              );
            }
          })}
        </Grid>
      </Container>
    </Box>
  );
}
